import Principal from '../screens/Principal.vue';
import HorasExtras from '../screens/HorasExtras.vue';
import AdicionalNoturno from '../screens/AdicionalNoturno.vue';
import RemuneracaoFerias from '../screens/RemuneracaoFerias.vue';
import FaltasAfastamentos from '../screens/FaltasAfastamentos.vue'
import ContratoTrabalho from '../screens/ContratoTrabalho.vue'
import CustoFuncionario from '../screens/CustoFuncional.vue'
import CalculoAtestado from '../screens/CalculoAtestado.vue';
import CalculoSeguroDesemprego from '../screens/CalculoSeguroDesemprego.vue';
export const routes = [

    { path: '/', redirect: '/calculos' },

    {path:'/calculos', name:'principal',component: Principal},  
    {path:'/calculos/horasExtras/:id', name:'horasExtras',component: HorasExtras},
    {path:'/calculos/adicionalNoturno/:id', name:'adicionalNoturno',component: AdicionalNoturno},
    {path:'/calculos/remuneracaoFerias/:id', name:'remuneracaoFerias',component: RemuneracaoFerias},
    {path:'/calculos/faltasAfastamentos/:id', name:'faltasAfastamentos',component: FaltasAfastamentos},   
    {path:'/calculos/contratotrabalho/:id', name:'contratotrabalho',component: ContratoTrabalho}, 
    {path:'/calculos/custoFuncionario/:id', name:'custoFuncionario',component: CustoFuncionario}, 
    {path:'/calculos/calculoAtestado/:id', name:'calculoAtestado',component: CalculoAtestado},
    {path:'/calculos/calculoSeguroDesemprego/:id', name:'calculoSeguroDesemprego',component: CalculoSeguroDesemprego},
];


// WEBPACK FOOTER //
// ./src/routes/index.js